import i18next, {Namespace, ParseKeys, TOptions} from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next, TransProps, useTranslation as i18nUseTranslation, Trans as I18nTrans} from 'react-i18next'
//translations
import it from './it/it.json'
import itCountryLabels from 'react-phone-number-input/locale/it'

import 'dayjs/locale/it'
import {_DefaultNamespace} from 'react-i18next/TransWithoutContext'
import {HTMLProps} from 'react'

export const APP_LANGUAGES = [{label: 'Italiano (IT)', code: 'it', flagCode: 'it', json: it}] as const
export const COUNTRY_LABELS = {
    it: itCountryLabels
}

i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: Object.fromEntries(APP_LANGUAGES.map(language => [language.code, language.json])),
        ns: [],
        defaultNS: '',
        keySeparator: false,
        fallbackLng: APP_LANGUAGES[0].code,
        debug: false,
        react: {
            useSuspense: false
        },
        supportedLngs: APP_LANGUAGES.map(language => language.code),
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'i18nextLng'
        }
    })

export const changeAppLanguage = async (nextLanguage: (typeof APP_LANGUAGES)[number]['code']) => {
    await i18n.changeLanguage(nextLanguage)
}

/*These types are needed to get the TKey list*/
type RemoveSuffix<S extends string> = S extends `${infer P}_other` | `${infer P}_one` | `${infer P}_zero` ? P : S
type FlattenObjectKeys<T, Prefix extends string = ''> = {
    [K in keyof T & string]: T[K] extends object
        ? FlattenObjectKeys<T[K], `${Prefix}${K}:`>
        : RemoveSuffix<`${Prefix}${K}`>
}[keyof T & string]

export type TKey = RemoveSuffix<FlattenObjectKeys<typeof it>>

export const useTranslation = () => {
    const translation = i18nUseTranslation()

    return {
        ...translation,
        t: (key: TKey, options?: TOptions) => translation.t(key, options)
    }
}

export const Trans = <
    Key extends ParseKeys<Ns, TOpt, KPrefix>,
    Ns extends Namespace = _DefaultNamespace,
    TOpt extends TOptions = Record<string, unknown>,
    KPrefix = undefined,
    E = HTMLProps<HTMLDivElement>,
    I18NKey extends TKey | undefined = undefined
>({
    i18nKey,
    ...props
}: Omit<TransProps<Key, Ns, TOpt, KPrefix, E>, 'i18nKey'> & {i18nKey: I18NKey}) => (
    <I18nTrans {...props} i18nKey={i18nKey} />
)

const i18n = {...i18next, t: (key: TKey, options?: TOptions) => i18next.t(key, options)}

export default i18n
